import { Gap } from 'components/layout';
import { ModalLeave } from 'components/ModalLeave';
import { VideoPlayer } from 'components/videoPlayer';
import { IPlayerDesign } from 'queries/videoReply/types';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-covideo-common';
import { BsCameraVideoFill } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';
import { ModalUploadRecordVideo } from './ModalUploadRecordVideo';
import { useTranslation } from 'react-i18next';

export interface VideoPreviewReplyProps {
  videoBlob: Blob;
  handleGoToRecordHome: () => void;
  playerDesign: IPlayerDesign | undefined;
}

export const VideoPreviewReply = ({
  videoBlob,
  handleGoToRecordHome,
  playerDesign,
}: VideoPreviewReplyProps) => {
  const { t } = useTranslation();
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [isModalLeaveOpen, setIsModalLeaveOpen] = useState(false);
  const [isModalUploadOpen, setIsModalUploadOpen] = useState(false);

  useEffect(() => {
    const url = URL.createObjectURL(videoBlob);
    setVideoUrl(url);

    // Clean up the URL object when the component unmounts or the videoSource changes
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [videoBlob]);

  return (
    <Gap
      style={{ minHeight: '100vh' }}
      flexDirection='column'
      justifyContent='center'
    >
      {videoUrl && (
        <VideoPlayer
          videoRef={React.createRef()}
          width={'100%'}
          preventWideSize={true}
          videoSource={videoUrl}
          playerBackgroundColor={playerDesign?.playerBackgroundColor}
          playerIconsColor={playerDesign?.playerIconsAndTextColor}
          playButtonPosition={playerDesign?.playButtonPosition}
          isAutomotive={true}
          hidePoweredBy={true}
          interactiveCTAs={[]}
        />
      )}
      <Gap
        style={{ width: '100%' }}
        flexDirection='flex-start'
        justifyContent='center'
      >
        <Button
          variant='destructive'
          text={t('Record new video')}
          icon={<MdEmail size={22} />}
          onClick={() => setIsModalLeaveOpen(true)}
        />
        <Button
          variant='secondary'
          text={t('Send video')}
          icon={<BsCameraVideoFill size={18} />}
          onClick={() => setIsModalUploadOpen(true)}
        />
      </Gap>
      {isModalLeaveOpen && (
        <ModalLeave
          title={t('Leave without saving the recording?')}
          text={t(
            'Your recording will not be saved. This action can’t be undone.'
          )}
          confirmButtonText={t('Continue')}
          discardButtonText={t('Leave')}
          onClickDiscardButton={handleGoToRecordHome}
          onClickConfirmButton={() => setIsModalLeaveOpen(false)}
          handleModalClose={() => setIsModalLeaveOpen(false)}
        />
      )}
      {isModalUploadOpen && (
        <ModalUploadRecordVideo
          handleModalClose={() => setIsModalUploadOpen(false)}
          videoBlob={videoBlob}
        />
      )}
    </Gap>
  );
};
